import { PAGE_BUILDER_CODE_COMPONENT, PageBuilderItem } from '../page-builder-components.models';
import { DynamicInputModel, serializable, DynamicFormControlLayout, DynamicInputModelConfig } from '@ng-dynamic-forms/core';

export interface PageBuilderImageModelConfig extends DynamicInputModelConfig {
	binding?: string;
}

export class PageBuilderImageModel extends DynamicInputModel {
	@serializable() readonly type: string = 'page_builder_image'; 
	binding?: string;

	constructor(config: PageBuilderImageModelConfig, layout?: DynamicFormControlLayout) {
		super(config, layout);
		this.binding = config.binding;
	}

	static initModel(_component: PageBuilderItem): PageBuilderImageModel { 
		const formModel = new PageBuilderImageModel({
			id: _component.ID,
			name: _component.ID,
			label: _component.LABEL,
			value: _component.DEFAULT_VALUE,
			required: _component.IS_REQUIRED,
			readOnly: _component.IS_READONLY,
			hidden: _component.IS_VISIBLE,
			binding: _component.BINDING,
		});
		return formModel;
	}

    static getProperties() {
        return {
            CODE: PAGE_BUILDER_CODE_COMPONENT.IMAGE,
            NAME: 'Image',
            ICON: 'image',
            PROPERTIES: [
                { ID: 'TYPE_COMPONENT', CODE: PAGE_BUILDER_CODE_COMPONENT.TEXTBOX, LABEL: 'Type', DEFAULT_VALUE: 'Image', IS_READONLY: true },
                { ID: 'INDEX', CODE: PAGE_BUILDER_CODE_COMPONENT.NUMERIC_TEXTBOX, LABEL: 'Index' },
                { ID: 'BINDING', CODE: PAGE_BUILDER_CODE_COMPONENT.TEXTBOX, LABEL: 'Binding', DEFAULT_VALUE: null },
                { ID: 'DEFAULT_VALUE', CODE: PAGE_BUILDER_CODE_COMPONENT.FILE_PICKER, LABEL: 'Sélectionnez une image' },
            ]
        };
    }
}